module.exports = __webpack_public_path__ + "img/access-drop-down.eb2897f4.svg";